module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid20_980x858.d2071f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid20_980x858.jpg
// module id = CyWp
// module chunks = 0